import { render, staticRenderFns } from "./LayoutElement.vue?vue&type=template&id=00a73062&scoped=true"
import script from "./LayoutElement.vue?vue&type=script&lang=js"
export * from "./LayoutElement.vue?vue&type=script&lang=js"
import style0 from "./LayoutElement.vue?vue&type=style&index=0&id=00a73062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a73062",
  null
  
)

export default component.exports